import { Button, colors, Stack, Typography } from '@ui-components/neo.tax';
import * as React from 'react';

import { ActionButtonModalProps } from './ActionButtonModal';

export interface ActionButtonProps {
  isQuestionValid?: boolean;
  warningText?: string;
  onClick?: () => void;
  disabled: boolean;
  isLoading: boolean;
  loadingText: string;
  buttonText: string;
  startIcon?: React.ReactNode;
  position: 'topRight' | 'bottom';
  actionButtonModalProps?: ActionButtonModalProps;
}

export const ActionButton = ({
  buttonText,
  disabled,
  isLoading,
  isQuestionValid,
  loadingText,
  onClick,
  position,
  startIcon,
  warningText,
}: ActionButtonProps): React.ReactElement => (
  <Stack direction="column" alignItems={position === 'topRight' ? 'end' : 'start'}>
    {!isQuestionValid && warningText && (
      <Typography fontSize="xs" color={colors.gray[500]}>
        {warningText}
      </Typography>
    )}
    <Button
      size="xs"
      variant="primary"
      color="primary"
      rounded="regular"
      onClick={onClick}
      disabled={disabled}
      startIcon={startIcon}
    >
      {isLoading ? loadingText : buttonText}
    </Button>
  </Stack>
);
